import * as React from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import useEscapeKey from "../models/useEscapeKey";
import BaseObject from "../models/BaseObject";
import { RefObject, useEffect, useRef } from "react";
import useEnterKeyAsOk from "../models/useEnterKeyAsOk";
import { getLeftTopFromStyle, setLeftTopInStyle } from "../modelViews/GraficElementUtils";

var dialogPointerIsDown = false;
var pStart = { x: 0, y: 0 };
let dialogLastPointerId = 0;

export function FieldSet(props: { label?: string; children: any; widthTable?: string; style?: any }) {
  const widt = props.widthTable ? props.widthTable : "100%";
  return (
    <table style={{ width: widt, ...props.style }} className="fieldGroup">
      <colgroup>
        <col style={{ width: "100px" }} />
        <col style={{ maxWidth: "100%" }} />
      </colgroup>
      {/* <thead> // needs to be commented out because of background color in thead
        <tr>
          <th></th>
          <th></th>
        </tr>
      </thead> */}
      <tbody> {props.children}</tbody>
    </table>
  );
}
export function Field(props: { label?: string; labelStyle?: React.CSSProperties; children: any }) {
  return (
    <tr>
      <td style={{ verticalAlign: "middle", ...props.labelStyle }}>{props.label}</td>

      <td style={{ verticalAlign: "middle" }}> {props.children}</td>
    </tr>
  );
}

export default function BaseDialog(props: {
  dialogId?: string;
  className?: string;
  onClose?: () => boolean;
  onOk?: () => boolean;
  onOkAsync?: () => Promise<boolean>;
  onAbort?: () => boolean;
  onAbortAsync?: () => Promise<boolean>;
  onMove?: () => void;
  onClick?: () => void;
  onDoubleClick?: () => void;
  onMouseUp?: (ev: any) => void;
  onMouseDown?: (ev: any) => void;
  onMouseMove?: (ev: any) => void;
  onMouseEnter?: (ev: any) => void;
  onMouseLeave?: (ev: any) => void;
  onClickHeader?: () => void;
  style?: React.CSSProperties;
  objToEdit?: BaseObject;
  title?: string;
  titleSuffix?: any;
  noOkButton?: boolean;
  okDisabled?: boolean;
  noAbortButton?: boolean;
  okCaption?: string;
  abortCaption?: string;
  tabStrip?: any;
  children: any;
  moreButtons?: any;
  noPaddingForContent?: boolean;
  noScroll?: boolean;
  headerRef?: RefObject<HTMLDivElement> | null;
  enterAsOk?: boolean;
  hideXButton?: boolean;
  headerHelpButton?: any;
  moreHeaderButtons?: any;
  isModal?: boolean;
  noMinHeight?: boolean;
  noMinWidth?: boolean;
  backgroundColor?: string;
  bodyNoMinWidth?: boolean;
}) {
  var {
    dialogId,
    className,
    onClose,
    onOk,
    onOkAsync,
    onMove,
    onMouseUp,
    onMouseDown,
    onMouseMove,
    onMouseEnter,
    onMouseLeave,
    onClickHeader,
    objToEdit,
    style,
    title,
    titleSuffix,
    okCaption,
    abortCaption,
    noAbortButton,
    noOkButton,
    noScroll,
    tabStrip,
    moreButtons,
    noPaddingForContent,
    headerRef,
    enterAsOk,
    hideXButton,
    headerHelpButton,
    moreHeaderButtons,
    isModal,
    noMinHeight,
    noMinWidth,
    bodyNoMinWidth,
    backgroundColor,
  } = props;

  headerRef ||= useRef<HTMLDivElement>(null);

  const dialogRef = useRef<HTMLDivElement>(null);
  const closing = useRef(false);

  useOnChangeWatcher(state.dialogManager);
  const doCenter = useRef(false);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      state.dialogManager.doCenter = false;
      const dialogElement = dialogRef.current;
      if (dialogElement) {
        if (state.dialogManager.doCenter) {
          const rect = dialogElement.getBoundingClientRect();
          const left = (window.innerWidth - rect.width) / 2;
          const top = (window.innerHeight - rect.height) / 2;
          dialogElement.style.left = `${left}px`;
          dialogElement.style.top = `${top}px`;

          console.log(
            "show Dialog:",
            state.dialogManager.dialogStack[state.dialogManager.dialogStack.length - 1].dialogId,
            dialogId,
          );

          if (
            state.dialogManager.dialogStack.length <= 1 ||
            state.dialogManager.dialogStack[state.dialogManager.dialogStack.length - 1].dialogId === dialogId
          ) {
            dialogElement.style.display = "flex";
          } else {
            dialogElement.style.display = "none";
          }
        }
      }
    }, 200);

    return () => window.clearTimeout(timerId);
  }, [state.dialogManager]);

  function onPointerMove(event: any) {
    event.stopPropagation();
    event.preventDefault();

    const elmDialogWrapper = dialogRef.current?.parentElement as HTMLDivElement;
    if (elmDialogWrapper) {
      if (!dialogPointerIsDown) {
        return;
      }

      const p = {
        x: event.clientX || event.touches[0]?.clientX,
        y: event.clientY || event.touches[0]?.clientY,
      };

      const pCurrent = getLeftTopFromStyle(elmDialogWrapper);

      const delta = { x: p.x - pStart.x, y: p.y - pStart.y };

      pCurrent.x += delta.x;
      pCurrent.y += delta.y;

      setLeftTopInStyle(elmDialogWrapper, pCurrent);
      pStart = p;

      if (onMove) {
        onMove();
      }
    }
  }

  function onPointerDown(event: any) {
    event.stopPropagation();
    if (headerRef?.current) {
      // elm.setPointerCapture(event.pointerId);
      pStart = {
        x: event.clientX || event.touches[0]?.clientX,
        y: event.clientY || event.touches[0]?.clientY,
      };

      headerRef.current.setPointerCapture(event.pointerId);
      dialogLastPointerId = event.pointerId;
      dialogPointerIsDown = true;
    }
  }

  function onPointerUp(event: any) {
    try {
      event.stopPropagation();
      if (headerRef?.current) {
        dialogPointerIsDown = false;
        headerRef.current.releasePointerCapture(dialogLastPointerId);
        dialogLastPointerId = 0;
      }
    } catch (e) {}
  }

  async function onOkClick() {
    if (closing.current || props.okDisabled) return;
    if (props.onOk) {
      if (props.onOk()) {
        handleClose(true);
      }
      return;
    }

    if (props.onOkAsync) {
      closing.current = true;
      try {
        if (await props.onOkAsync()) handleClose(true);
      } finally { closing.current = false; }
      return;
    }

    handleClose(true);
  }

  async function onAbortClick() {
    if (closing.current) return;
    if (props.onAbortAsync) {
      closing.current = true;
      try {
        if (await props.onAbortAsync()) handleClose(false);
      } finally { closing.current = false; }
      return;
    }
    if (props.onAbort) {
      if (props.onAbort()) {
        handleClose(false);
      }
    } else {
      handleClose(false);
    }
  }

  function handleClose(result?: boolean) {
    state.dialogManager.closeDialog(result);
  }

  const isTopDialog = !state.dialogManager.dialogStack.some(entry => entry.preserveOnOpen)
    || (state.dialogManager.lastStackEntry?.dialogId || "") === (dialogId || "");
  if (isTopDialog) state.dialogManager.onClose = () => {
    if (onClose) {
      return onClose();
    }

    return true;
  };

  useEscapeKey(() => {
    if (!state.guideMode.sequenceRunning && isTopDialog) {
      if (props.onAbortAsync) void onAbortClick();
      else handleClose();
    }
  });
  useEnterKeyAsOk(() => {
    if (!state.guideMode.sequenceRunning && isTopDialog) {
      if (enterAsOk) {
        onOkClick();
      }
    }
  });

  if (noAbortButton == undefined) {
    noAbortButton = false;
  }

  if (noOkButton == undefined) {
    noOkButton = false;
  }

  let buttons: any = (
    <div className="dialogButtons">
      <div className="dialogFooterLeftText"></div>

      {!noAbortButton && (
        <button id="BaseDialog_abort" className="button" onClick={onAbortClick}>
          {abortCaption || state.translate("cancle", "cancle")}
        </button>
      )}

      {moreButtons}

      {!noOkButton && (
        <button
          id="BaseDialog_ok"
          className="button"
          disabled={props.okDisabled}
          onClick={async () => {
            await onOkClick();
          }}
          style={{ backgroundColor: enterAsOk ? "orange" : undefined }}
          autoFocus
        >
          {okCaption || state.translate("ok", "ok")}
        </button>
      )}

      <div className="dialogFooterRightText"></div>
    </div>
  );

  if (noAbortButton && noOkButton && !moreButtons) {
    buttons = undefined;
  }

  className = (className || "") + " dialog";

  // zIndex: "1" avoids "click throuh"

  if (isModal == undefined) {
    isModal = state.dialogManager.isModal;
  }

  return (
    <div
      ref={dialogRef}
      id="dialog"
      className={className + " " + "dialog-" + (dialogId || "main")}
      onMouseDown={(ev) => {
        if (onMouseDown) {
          onMouseDown(ev);
        }
      }}
      onMouseMove={(ev) => {
        if (onMouseMove) {
          onMouseMove(ev);
        }
      }}
      onMouseUp={(ev) => {
        if (onMouseUp) {
          onMouseUp(ev);
        }
      }}
      onMouseEnter={(ev) => {
        if (onMouseEnter) {
          onMouseEnter(ev);
        }
      }}
      onMouseLeave={(ev) => {
        if (onMouseLeave) {
          onMouseLeave(ev);
        }
      }}
      style={{
        minHeight: noMinHeight ? "auto" : undefined,
        minWidth: noMinWidth ? "auto" : undefined,
        backgroundColor: backgroundColor || "white",
        zIndex: "20",
        pointerEvents: "auto",
        userSelect: "none",
        ...style,
      }}
    >
      <div
        ref={headerRef}
        className="dialogHeader"
        onClick={(ev) => {
          ev.stopPropagation();
          props.onClick && props.onClick();
        }}
        onDoubleClick={(ev) => {
          ev.stopPropagation();
          props.onDoubleClick && props.onDoubleClick();
        }}
        onPointerDown={!isModal ? onPointerDown : undefined}
        onPointerMove={!isModal ? onPointerMove : undefined}
        onPointerUp={!isModal ? onPointerUp : undefined}
        style={{ cursor: !isModal ? "move" : undefined, whiteSpace: "nowrap" }}
      >
        {/* cheating to center elements */}
        {!hideXButton && (
          <div className="dialogHeaderButton" style={{ visibility: "hidden" }}>
            <i className="las la-times" />
          </div>
        )}
        <div className="dialogHeaderTitle" style={{ marginLeft: "auto" }}>
          {title}&nbsp;&nbsp;{titleSuffix}
        </div>
        <div style={{ marginLeft: "auto" }}></div>
        {moreHeaderButtons}
        {headerHelpButton}
        {!hideXButton && (
          <div
            className="dialogHeaderButton"
            onPointerDown={(event) => {
              event.stopPropagation();
            }}
            onPointerMove={(event) => {
              event.stopPropagation();
            }}
            onPointerEnter={(event) => {
              event.stopPropagation();
            }}
            onClick={(event) => {
              event.stopPropagation();
              if (props.onAbortAsync) void onAbortClick();
              else handleClose(false);
            }}
          >
            <i className="las la-times" />
          </div>
        )}
      </div>
      {tabStrip && <div className="dialogHeader"> {tabStrip} </div>}
      <div
        className="dialogBody"
        style={{
          position: "relative",
          // width: "max-content",
          padding: noPaddingForContent ? undefined : "20px", // no itx
          overflow: noScroll ? "hidden" : "auto",
          textAlign: "left",
          width: "100%",
          minWidth: bodyNoMinWidth ? "auto" : "max-content",
        }}
      >
        {props.children}
      </div>
      {buttons}
    </div>
  );
}
